import { useUsers } from "../api";

interface UserPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  id?: string;
  allowUnassigned?: boolean;
  className?: string;
}

/** Owner selector backed by the system user list. A plain native select —
 *  the user list is short (the leadership team) so a combobox is overkill. */
export function UserPicker({ value, onChange, id, allowUnassigned = true, className }: UserPickerProps) {
  const users = useUsers();
  return (
    <select
      id={id}
      className={
        className ??
        "h-9 w-full rounded-xl border border-input bg-background px-2 text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
      }
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value || null)}
    >
      {allowUnassigned && <option value="">Unassigned</option>}
      {users.data?.map((u) => (
        <option key={u.id} value={u.id}>
          {u.display_name}
        </option>
      ))}
    </select>
  );
}
